export const redirectAfterLogout = (redirectBase64: string) => {
	const href = atob(redirectBase64.replace("-", "+").replace("_", "/"));
	const url = new URL(href);

	url.searchParams.set("loggedOut", "true");

	window.location.href = url.toString();
};
